import React from "react";
import "../iubenda";

const PrivacyPolicy = () => {
  return (
    <>
      <a
        href="https://www.iubenda.com/privacy-policy/48266867"
        className="iubenda-white no-brand iubenda-noiframe iubenda-embed iubenda-noiframe iub-body-embed"
        title="Privacy Policy"
      >
        Privacy Policy
      </a>
    </>
  );
};

export default PrivacyPolicy;
